import { onError } from "@apollo/client/link/error";
import { SessionError } from "src/pages/api/auth/getUserTokenFromApi";
import { isAppWebview } from "src/utils/isAppWebview";
import { signOut } from "src/utils/nextAuth";
import { removeAccessToken } from "src/utils/removeAccessToken";

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (networkError) {
    if (typeof window !== "undefined" && typeof window.newrelic !== "undefined")
      window.newrelic.noticeError(networkError, { ...operation });

    console.error("Network error occurred:", networkError);
  }

  if (graphQLErrors) {
    for (const error of graphQLErrors) {
      const statusCode =
        (typeof error?.extensions?.code === "number" &&
          error.extensions.code) ||
        (typeof error?.extensions?.status_code === "number" &&
          error.extensions.status_code) ||
        0;
      if (
        typeof window !== "undefined" &&
        typeof window.newrelic !== "undefined"
      )
        window.newrelic.noticeError(error, { statusCode, ...operation });

      if (
        error.extensions?.name === SessionError.INVALID_TOKEN_ERROR ||
        error.extensions?.name === SessionError.EXPIRED_TOKEN_ERROR
      ) {
        if (!isAppWebview()) {
          void signOut();
          void removeAccessToken();
        }
      }

      console.error("GraphQL Error occurred:", error);
    }
  }
  return undefined;
});

export default errorLink;
